<script setup>
import { ref, onMounted, defineExpose, getCurrentInstance } from "vue";
import { useRouter } from 'vue-router'
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import jobFairUserService from "@/pages/user/services/jobFair/jobFairUserService";
import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
import AlertCustomModal from "./AlertCustomModal.vue"
import JobFairResumeModalGnb from "@/pages/user/components/modal/jobFair/JobFairResumeModalGNB.vue";
import { useAlertStore } from "../../../../../stores/alertStore";
const { $alert, $confirm} = useAlertStore();

const loadingStore = usePageLoadingStore()
const { $pageListBoardNo, $number, $yyyymmddHHmmss } = getCurrentInstance().appContext.config.globalProperties;

const router = useRouter()

const ojfIds = ref(0);
const jobNoticeSeqs = ref(0);
const applicantYns = ref('N');
const modes = ref(null);

const resumeList = ref([]);
const currentPage = ref(1);
const pageSize = 5;
const totalPages = ref(1);
const totalCount = ref(0);

const baseModal = ref(null);
const resolvePromise = ref(null);

const alertCustomModal = ref(null);
const jobFairResumeModalGNB = ref(null);
const modalContent = ref([])

onMounted(()=>{
  setTimeout(()=>{
    baseModal.value.isAdminWrap = true;
  }, 500);
})

// 면접제안 시 채용공고 목록 조회
const ojfResumeListJobNoticeSeq = (ojfId, jobNoticeSeq) => {
  ojfIds.value = ojfId;
  jobNoticeSeqs.value = jobNoticeSeq;

  let paramObj = {
    ojfId: ojfId,
    jobNoticeSeq: jobNoticeSeq,
    pageNumber: currentPage.value,
    size: pageSize,
  }

  loadingStore.loading = true;
  jobFairUserService.ojfResumeListJobNoticeSeq(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          resumeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize, currentPage.value);
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

// 입사지원하기
const onClickCreateApplicant = async (ojfId, jobNoticeSeq, resumeId) => {
  ojfIds.value = ojfId;
  jobNoticeSeqs.value = jobNoticeSeq;
  const ok = await $confirm(["선택한 이력서로", "입사 지원 하시겠습니까?"], "입사지원");
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      ojfId: ojfId,
      jobNoticeSeq: jobNoticeSeq,
      resumeId: resumeId,
    }

    loadingStore.loading = true;
    jobFairUserService.ojfCreateApplyStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            // const result = res.data.result;
            alertCustomModal.value.show();

            baseModal.value.close();
            resolvePromise.value(true);
          }
        }).catch( (error) =>  {
      loadingStore.loading = false;
      console.log(error);
    });
  }
}

// 이력서 등록
const onClickResumeCreate = (id) => {
  const jobNoticeSeq = jobNoticeSeqs.value;
  const mode = modes.value;
  router.push({ name: 'MyPageJobFairResumeCreate', query : { ojfId: id, jobNoticeSeq: jobNoticeSeq, mode: mode } });
}

// 이력서 보기
const onClickMyResume = async (resumeId, ojfId, mode) => {
  const jobNoticeSeq = jobNoticeSeqs.value;
  const applicantYn = applicantYns.value; // 입사지원 여부

  jobFairResumeModalGNB.value.init(true, jobNoticeSeq, applicantYn, mode);
  jobFairResumeModalGNB.value.retrieveJobFairRecordDetail(resumeId, ojfId);
  await jobFairResumeModalGNB.value.show();

  baseModal.value.close();
  resolvePromise.value(false);
}

const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

const init = (applicantYn, mode) => {
  if (applicantYn) {
    applicantYn = 'Y'
  } else {
    applicantYn = 'N'
  }
  applicantYns.value = applicantYn;

  // 마이페이지 > 관심기업 > 채용공고
  // 마이페이지 > 관심공고
  // 이력서 등록 화면에서 이력서 등록 후지원 완료 시 마이페이지 이동하기 위한 데이터
  modes.value = mode;

  currentPage.value = 1;

}

const onSelectedPage = (pageNo) => {
  currentPage.value = pageNo;
  ojfResumeListJobNoticeSeq(ojfIds.value, jobNoticeSeqs.value);
}

defineExpose({
  show,
  init,
  ojfResumeListJobNoticeSeq,
})
</script>

<template>
  <Modal ref="baseModal">
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-title">
        <h3>이력서 선택</h3>
        <p>- 기존 등록된 이력서를 선택하여 기업에게 입사지원을 할 수 있습니다.</p>
        <p>- 새로운 이력서 작성을 원하실 경우 [새로운 이력서 등록하기]를 눌러주세요.</p>
        <p class="red">※ 지원 완료된 이력서는 수정이 불가하며, 제출한 이력서를 변경하고 싶으신 경우 입사지원 취소 후 새로운 이력서로 다시 지원할 수 있습니다.</p>
      </div>
      <div class="modal-body">
        <div class="list-top">
          <p>총 <span>{{ $number(totalCount)}}</span>개</p>
        </div>
        <div class="table-form">
          <table class="vertical" v-if="resumeList !== null">
            <colgroup>
              <col width="50px" />
              <col />
              <col width="220px" />
              <col width="220px" />
              <col width="50px" />
            </colgroup>
            <tr>
              <th class="text-center">번호</th>
              <th class="text-center">이력서 제목</th>
              <th class="text-center">최근 수정일</th>
              <th class="text-center">등록일</th>
              <th class="text-center">선택</th>
            </tr>
            <tr v-for="list in resumeList">
              <td class="text-center">{{ list.boardNo }}</td>
              <td class="text-center text-overflow long-overflow">
                <span class="file" v-if="list.fileYn === 'Y'" v-for="resumeAttaches in list.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                  {{ resumeAttaches.fileName }}
                </span>
                <span v-else class="clickable blue" @click="onClickMyResume(list.resumeId, ojfIds, modes)">
                  {{ list.title }}
                </span>
              </td>
              <td class="text-center">{{ $yyyymmddHHmmss(list.modifyDate) }}</td>
              <td class="text-center">{{ $yyyymmddHHmmss(list.createDate) }}</td>
              <td class="link text-center">
                <!-- 채용공고 선택 목록 데이터에서 resumeId에 데이터가 있으면 제안완료로 체크 (버튼 활성화/비활성화를 위한 데이터) -->
                <KSAPrimaryButton v-if="list.applyStateGb" text="지원완료" disabled="disabled" />
                <div v-else>
                  <KSATextButton v-if="applicantYns === 'N'" text="선택" @click="onClickCreateApplicant(ojfIds, jobNoticeSeqs, list.resumeId)" />
                </div>
              </td>
            </tr>
            <tr v-if="resumeList.length === 0">
              <td class="text-center" colspan="5">
                등록된 이력서가 없습니다.
              </td>
            </tr>
            <tr v-if="applicantYns === 'N'">
              <th class="text-left" style="font-weight: 400;"></th>
              <th colspan="4" class="link text-right" style="font-weight: 400; ">
                <KSATextButton text="[새로운 이력서 등록하기]" @click="onClickResumeCreate(ojfIds)" />
              </th>
            </tr>
          </table>
        </div>
        <Paginate
            v-if="resumeList.length > 0"
            v-model="currentPage"
            :page-count="totalPages"
            :click-handler="onSelectedPage"
        />
      </div>
      <div class="modal-footer mt-xs" style="justify-content: center;">
        <KSASecondaryButton class="gray_button" text="취소" @click="cancel" />
      </div>
    </div>
  </Modal>
  <AlertCustomModal ref="alertCustomModal" :content="modalContent" /> <!-- 커스텀 팝업: 입사지원 완료 -->
  <JobFairResumeModalGnb ref="jobFairResumeModalGNB" /> <!-- GNB용 이력서 보기 -->
  <!--
    <jobFairResumeModalGNB /> GNB용(MatchingJobFairDetailView) 이력서 보기를 만든 이유
    <JobFairResumeModal />의 복제 화면
    MatchingJobFairDetailView화면에서 '채용공고'탭에서 회사 클릭시 '채용공고 팝업'이 띄워지고 '입사지원' 버튼 클릭하면 현재화면으로 이동 되는데
    이 때, 기존에 있던 이력서 보기 팝업(<JobFairResumeModal />)을 띄우면 그 안에서도 조건에 따라 팝업을 띄우는데 이때 따라가다보면 '채용공고 팝업'을 띄우면서
    무한 재귀가 되어 GNB용 이력서 보기 팝업을 만듦
  -->
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.modal-inner {
  width: 598px !important;
}

.modal-title p {
  margin-bottom: 0 !important;
}
.red {
  color: $red_color !important;
}

.list-top {
  p {
    margin-right: 0;
    padding-left: 2px;
    &:first-of-type {
      padding-left: 0;
    }
  }
}

.table-form {
  p {
    margin-bottom: 0 !important;
  }
  .file, .clickable {
    cursor: pointer;
    color: $blue_color !important;
  }
  .clickable {
    text-decoration: underline;
  }
}

</style>